export default __webpack_public_path__ + "static/media/banner_signin.756ef37d.png";